/* tslint:disable */
/* eslint-disable */
/**
 * NameCheck API
 * assembly version: 1.0.0.0
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PositionDto,
    PositionDtoFromJSON,
    PositionDtoFromJSONTyped,
    PositionDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface PositionDtoPaginatedResultDto
 */
export interface PositionDtoPaginatedResultDto {
    /**
     * 
     * @type {number}
     * @memberof PositionDtoPaginatedResultDto
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionDtoPaginatedResultDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionDtoPaginatedResultDto
     */
    total?: number;
    /**
     * 
     * @type {Array<PositionDto>}
     * @memberof PositionDtoPaginatedResultDto
     */
    results?: Array<PositionDto> | null;
}

export function PositionDtoPaginatedResultDtoFromJSON(json: any): PositionDtoPaginatedResultDto {
    return PositionDtoPaginatedResultDtoFromJSONTyped(json, false);
}

export function PositionDtoPaginatedResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PositionDtoPaginatedResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'take': !exists(json, 'take') ? undefined : json['take'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(PositionDtoFromJSON)),
    };
}

export function PositionDtoPaginatedResultDtoToJSON(value?: PositionDtoPaginatedResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'take': value.take,
        'page': value.page,
        'total': value.total,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(PositionDtoToJSON)),
    };
}


